export const events = {
  add: {
    contactNumber: 'ADVISER_CONTACT_DETAILS_ADD_CONTACT_NUMBER'
  },
  set: {
    contactNumber: 'ADVISER_CONTACT_DETAILS_SET_CONTACT_NUMBER',
    publicEmail: 'ADVISER_CONTACT_DETAILS_SET_PUBLIC_CONTACT_EMAIL_ADDRESS'
  },
  edit: {
    contactNumber: {
      start: 'ADVISER_CONTACT_DETAILSE_START_EDITING_CONTACT_NUMBERS',
      stop: 'ADVISER_CONTACT_DETAILS_STOP_EDITING_CONTACT_NUMBER',
      cancel: 'ADVISER_CONTACT_DETAILS_CANCEL_EDITING_CONTACT_NUMBERS'
    }
  },
  deletes: {
    contactNumbers: {
      contactNumber: 'ADVISER_CONTACT_DETAILS_DELETE_CONTACT_NUMBER',
      modal: 'ADVISER_CONTACT_DETAILS_DELETE_CONTACT_NUMBER_MODAL',
      cancel: 'ADVISER_CONTACT_DETAILS_CANCEL_DELETING_CONTACT_NUMBER'
    }
  }
}

const { add, set, edit, deletes } = events

export const actions = {
  add: {
    contactNumber: (contactNumberType) => ({
      type: add.contactNumber,
      contactNumber: {
        contactNumberTypeId: contactNumberType.contactNumberTypeId,
        contactNumberType: contactNumberType.contactNumberType,
        contactNumber: null
      }
    })
  },
  edit: {
    contactNumbers: {
      start: (index) => ({
        type: edit.contactNumber.start,
        index
      }),
      stop: () => ({
        type: edit.contactNumber.stop
      }),
      cancel: () => ({
        type: edit.contactNumber.cancel
      })
    }
  },
  set: {
    contactNumber: (validationResult, contactNumber, index) => ({
      type: set.contactNumber,
      validationResult,
      contactNumber,
      index
    }),
    publicEmail: (validationResult, email) => ({
      type: set.publicEmail,
      validationResult: validationResult,
      publicContactEmailAddress: email
    })
  },
  deletes: {
    contactNumbers: {
      modal: (index) => ({
        type: deletes.contactNumbers.modal,
        index
      }),
      contactNumber: () => ({
        type: deletes.contactNumbers.contactNumber
      }),
      cancel: () => ({
        type: deletes.contactNumbers.cancel
      })
    }
  }
}
